'use client';

import { Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FilterIcon } from '@/components/icons';
import useSearchStore from '@/publicSearch/store/useSearchStore';
import type { HeroSearchGuidance } from './heroSearchGuidance';

type Props = {
  guidance: HeroSearchGuidance;
  sx?: object;
};

export default function HeroSearchGuidanceChip({ guidance, sx }: Props) {
  const setOpenBasicSearchDialog = useSearchStore(
    (s) => s.setOpenBasicSearchDialog,
  );

  return (
    <Box
      role="status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 0.75,
        maxWidth: '100%',
        px: 1,
        py: 0.25,
        borderRadius: '6px',
        border: '1px solid',
        borderColor: (t) => alpha(t.palette.primary.main, 0.35),
        bgcolor: (t) => alpha(t.palette.primary.main, 0.1),
        color: 'primary.dark',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.3,
        boxShadow: (t) => `0 1px 3px ${alpha(t.palette.common.black, 0.08)}`,
        ...sx,
      }}
    >
      <Box component="span">{guidance.message}</Box>
      {guidance.showOpenBasicSearch ? (
        <Button
          type="button"
          size="small"
          variant="text"
          onClick={() => setOpenBasicSearchDialog(true)}
          startIcon={
            <FilterIcon sx={{ fontSize: '14px !important' }} color="primary" />
          }
          sx={{
            p: 0,
            minWidth: 0,
            fontSize: 11,
            fontWeight: 700,
            lineHeight: 1.3,
            textTransform: 'none',
            color: 'primary.main',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            '& .MuiButton-startIcon': {
              mr: 0.5,
              ml: 0,
            },
            '&:hover': {
              bgcolor: 'transparent',
              textDecoration: 'underline',
            },
          }}
        >
          Open Basic search
        </Button>
      ) : null}
    </Box>
  );
}
